import React from "react";

import * as Sentry from "@sentry/react";
import { ApolloProvider, useQuery } from "@apollo/react-hooks";
import { CssBaseline, ThemeProvider } from "@material-ui/core";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import { BrowserRouter as Router } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { Provider as StateProvider } from "react-redux";

import Routes from "./Routes";

import {
  AuthProvider,
  PageViewProvider,
  TealiumProvider,
} from "@hubcapp/context";
import { CustomDateFnsUtils } from "@ds-developer/frontend";
import { FlagsProvider } from "flagged";
import { createTheme } from "@hubcapp/theme";
import { store } from "@hubcapp/state";
import { useSettings } from "@hubcapp/hooks";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";
import getFeatureFlags from "graph-ql/getDsGlobalConfig.graphql";

import client from "client";

if (
  !process.env.DS_ENVIRONMENT ||
  process.env.DS_ENVIRONMENT.toUpperCase() === "PROD"
) {
  Sentry.init({
    dsn:
      "https://7ffd965a0f524350ad46a81dfc780dbf@o284266.ingest.sentry.io/5192331",
    environment: process.env.DS_ENVIRONMENT,
    release: process.env.REACT_APP_VERSION,
    normalizeDepth: 10,
  });
}

Sentry.configureScope(function (scope) {
  scope.setTag("originatingPlatform", "Hubcapp");
});

const notistackRef = React.createRef();

const App = () => {
  const { settings } = useSettings();
  const { data: featuresData } = useQuery(getFeatureFlags, { client });
  const features = featuresData?.getDsGlobalConfig;
  console.log("App version:", window._env_.REACT_APP_release_version);
  return (
    <StateProvider store={store}>
      <ThemeProvider theme={createTheme(settings)}>
        <SnackbarProvider maxSnack={8} ref={notistackRef}>
          <AuthProvider>
            <ApolloProvider client={client}>
              <FlagsProvider features={features}>
                <TealiumProvider>
                  <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
                    <CssBaseline />
                    <Router>
                      <ScrollToTop />
                      <PageViewProvider>
                        <Routes />
                      </PageViewProvider>
                    </Router>
                  </MuiPickersUtilsProvider>
                </TealiumProvider>
              </FlagsProvider>
            </ApolloProvider>
          </AuthProvider>
        </SnackbarProvider>
      </ThemeProvider>
    </StateProvider>
  );
};

export default App;
